import React from 'react';

export default function TigerEarsSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="14.65,18.18 6.87,18.18 7.46,13.68 15.25,13.68" fill="#955834" />
      <polygon points="31.52,18.18 23.73,18.18 24.33,13.68 32.11,13.68" fill="#955834" />
      <polygon points="14.64,21.02 7.45,18.04 10.43,10.85 17.62,13.83" fill="#955834" />
      <polygon points="7.45,18.04 6.67,17.65 9.65,10.46 10.43,10.85" fill="#492B19" opacity="0.95" />
      <polygon points="34.1,18.04 26.91,21.02 23.93,13.83 31.13,10.85" fill="#955834" />
      <polygon points="26.91,21.02 34.1,18.04 33.33,17.65 26.13,20.63" fill="#492B19" opacity="0.95" />
      <polygon points="26.91,21.02 26.13,20.63 23.16,13.44 23.93,13.83" fill="#492B19" opacity="0.95" />
      <polygon points="11.59,27.29 2.0,23.32 5.97,13.73 15.56,17.7" fill="#955834" />
      <polygon points="38.0,23.32 28.41,27.29 24.44,17.7 34.03,13.73" fill="#955834" />
      <polygon points="31.53,21.75 10.77,21.75 10.77,19.16 31.53,19.16" fill="#955834" />
      <polygon points="10.77,21.75 31.53,21.75 29.97,20.98 9.21,20.98" fill="#492B19" opacity="0.95" />
      <polygon points="10.77,21.75 9.21,20.98 9.21,18.38 10.77,19.16" fill="#492B19" opacity="0.95" />
      <polygon points="34.12,29.54 31.53,29.54 31.53,19.16 34.12,19.16" fill="#955834" />
      <polygon points="31.53,29.54 34.12,29.54 32.56,28.76 29.97,28.76" fill="#492B19" opacity="0.95" />
      <polygon points="31.53,29.54 29.97,28.76 29.97,18.38 31.53,19.16" fill="#492B19" opacity="0.95" />
      <polygon points="10.77,29.54 8.17,29.54 8.17,19.16 10.77,19.16" fill="#955834" />
      <polygon points="8.17,29.54 10.77,29.54 9.21,28.76 6.62,28.76" fill="#492B19" opacity="0.95" />
      <polygon points="8.17,29.54 6.62,28.76 6.62,18.38 8.17,19.16" fill="#492B19" opacity="0.95" />
    </svg>
  );
}
